import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatisIrisGiin = () => {
  const urlConfig = {
    name: "IrisGiin.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/IRIS+.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="IRIS+ (GIIN)"
            title={"IRIS+ GIIN Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What is the IRIS+ System? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The IRIS+ System, developed by the Global Impact Investing Network
              (GIIN), is a globally recognized framework that provides
              standardized metrics and tools for measuring, managing, and
              optimizing the social, environmental, and financial performance of
              impact investments.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              It serves as a common language for investors, asset managers,
              enterprises, and other stakeholders to define, track, and compare
              impact outcomes across different sectors, geographies, and
              investment strategies.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              Key features of the IRIS+ system include:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Standardized Impact Metrics — Based on global best practices and
                aligned with frameworks like the SDGs (Sustainable Development
                Goals).
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Impact Theme Guidance — Provides thematic pathways (e.g.,
                affordable housing, clean energy, financial inclusion) to guide
                users in selecting relevant metrics.
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Evidence-Based Research — Offers evidence maps linking
                activities to likely outcomes, helping investors connect
                strategy with results.
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Alignment with Global Standards — Integrates with systems like
                the SDGs, IFC Operating Principles, GIIRS, and IMP’s five
                dimensions of impact.
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Data Aggregation and Benchmarking — Allows investors to
                aggregate data across portfolios and compare results for
                benchmarking and reporting.
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              IRIS+ helps the impact investing community improve transparency,
              accountability, comparability, and decision-making, enabling
              investments that drive measurable and meaningful impact alongside
              financial returns.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <a
            href="https://iris.thegiin.org/catalog/download/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access Full IRIS+ System Documentation" />
          </a> */}

          <DownloadZipButton
            config={urlConfig}
            title="Access Full IRIS+ System Documentation"
            externalHref="https://iris.thegiin.org/catalog/download/"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatisIrisGiin;
